import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 実行メタデータ表示コンポーネント
 *
 * 実行時間、終了コード、タイムアウト状態を表示。
 * ステータスアイコンで成功/失敗/タイムアウトを視覚的に表示。
 * classNames でスタイルをカスタマイズ可能。
 */
import { CheckCircle, Clock, XCircle } from 'lucide-react';
import { cn, formatExecutionTime } from '../utils';
export function ExecutionMetadata({ executionTimeMs, exitCode, success, timedOut, className, classNames, }) {
    return (_jsxs("div", { className: cn('flex flex-wrap items-center gap-3 text-xs', classNames?.root, className), children: [_jsx(StatusIcon, { success: success, timedOut: timedOut }), _jsx("span", { children: formatExecutionTime(executionTimeMs) }), exitCode !== 0 && _jsxs("span", { className: classNames?.exitCodeError, children: ["\u7D42\u4E86\u30B3\u30FC\u30C9: ", exitCode] }), timedOut && (_jsx("span", { className: cn('inline-flex items-center rounded-full px-2 py-0.5 font-medium', classNames?.timeoutBadge), children: "\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8" }))] }));
}
function StatusIcon({ success, timedOut }) {
    if (timedOut) {
        return (_jsx(Clock, { className: "h-4 w-4 text-amber-600 dark:text-amber-500", "data-testid": "status-timeout" }));
    }
    if (success) {
        return (_jsx(CheckCircle, { className: "h-4 w-4 text-green-600 dark:text-green-500", "data-testid": "status-success" }));
    }
    return _jsx(XCircle, { className: "h-4 w-4 text-red-600 dark:text-red-500", "data-testid": "status-failed" });
}
//# sourceMappingURL=ExecutionMetadata.js.map